import React from 'react';
import Dictionary from '../../../model/Dictionary';
import './SeatsLegend.css';

const SeatsLegend = () => (
  <div className='seats-legend'>
    <div className='item'>
      <div className='marker open' />
      <label>{Dictionary.seats.open}</label>
    </div>
    <div className='item'>
      <div className='marker selected' />
      <label>{Dictionary.seats.selected}</label>
    </div>
    <div className='item'>
      <div className='marker reserved' />
      <label>{Dictionary.seats.reserved}</label>
    </div>
    <div className='item'>
      <div className='marker not-available' />
      <label>{Dictionary.seats.notAvailable}</label>
    </div>
  </div>
);

export default SeatsLegend;



// WEBPACK FOOTER //
// ./src/components/seats/seatsLegend/SeatsLegend.js